export default "__VITE_ASSET__CmDSCTYT__"